import React from 'react';
import { InputWrapper } from '../components/InputWrapper';
import { SelectWrapper } from '../components/SelectWrapper';
import { MessageWrapper } from '../components/MessageWrapper';
import { InputFileWrapper } from '../components/InputFileWrapper';

export const getElement = function(e, props) { 
    if(e.input === 'input') {
        return <InputWrapper {...props} placeholder={e.label} name={e.name} type={e.type} />
    }

    if(e.input === 'select') {
        return <SelectWrapper {...props} label={e.label} placeholder="" name={e.name} options={e.options} />
    }

    if(e.input === 'message') {
        return <MessageWrapper>{e.content}</MessageWrapper>
    }

    if(e.input === "file") {
        return <div><InputFileWrapper {...props} label={e.label} filename={e.filename} name={e.name} type="file" /></div>
    }
}

